import NewScheduleDuration from '@nile/client_management/src/Containers/ClientDetails/ClientContract/NewScheduleDuration';
import { RadioButton, TextField } from '@superops/ui-design-system';
import DatePicker from 'react-datepicker';
import React from 'react';
import styled from 'styled-components';
import dayjs from 'dayjs';
import {
  BackgroundIcon,
  getTranslatedText,
  TEXT_LENGTH
  // withErrorBoundary
} from '@nile/components/src';
import envConfig from '@nile/home/src/Config/env';
import { cloneDeep } from 'lodash';
import { injectIntl } from 'react-intl';
import withErrorBoundary from '../../../../components/src/HOC/withErrorBoundary';
import { SVGIcon } from '@superops/super-icons';

const RecursiveContainer = styled.div`
  .Superops-Choice {
    margin-top: 6px;
  }
`;

const DatePickerIconWrapper = styled.div`
  margin-right: 10px;
  opacity: 0.8;
`;

const TicketSchedulerFormContainer = styled.div`
  .Header-Input {
    max-width: 100% !important;
    margin-left: 0;
  }

  .scheduler-name,
  .scheduler-description {
    & .Polaris-TextField__Backdrop {
      border-bottom: none;
    }
    .Superops-TextField__Input {
      border: none !important;
    }
  }
`;

const maxRepeatInterval = {
  HOURLY: 23,
  DAILY: 31,
  WEEKLY: 4,
  MONTHLY: 12
};

const TicketSchedulerForm = (props) => {
  const { updateScheduleData, scheduleData, errors, intl } = props;
  const handleScheduleDataChange = (type, value) => {
    const clonedScheduleData = cloneDeep(scheduleData);
    clonedScheduleData[type] = value;
    updateScheduleData(clonedScheduleData);
  };
  const handleExecuteChange = (val) => {
    // setIsRecursive(val);
    handleScheduleDataChange('isRecursive', val);
  };
  const formatFieldsMap = ['startDateAndTime', 'endDateAndTime'];
  const handleScheduleChange = (val) => {
    let schedule = val;
    if (!schedule?.frequency) {
      schedule = {
        frequency: 'ONCE',
        data: {
          startDateAndTime: val
        }
      };
    }
    if (schedule?.frequency !== 'ONCE' && schedule?.data?.repeatInterval) {
      let repeatInterval = schedule.data?.repeatInterval;
      if (repeatInterval > maxRepeatInterval[schedule?.frequency]) {
        repeatInterval = maxRepeatInterval[schedule?.frequency];
      }
      schedule.data.repeatInterval = repeatInterval.toString().split('.')[0];
    }
    formatFieldsMap.forEach((field) => {
      if (schedule?.data?.[field])
        schedule.data = {
          ...schedule.data,
          [field]: dayjs(schedule.data[field]).format('YYYY-MM-DDTHH:mm:ss')
        };
    });
    handleScheduleDataChange('schedule', schedule);
  };

  const filterPassedTime = (time) => {
    const currentDate = new Date();
    const selectedDate = new Date(time);

    return currentDate.getTime() < selectedDate.getTime();
  };

  const filterPassedDate = (date) => {
    const currentDate = new Date();
    const selectedDate = new Date(date);

    return (
      currentDate.toLocaleDateString() <= selectedDate.toLocaleDateString()
    );
    // return currentDate.getTime() <= selectedDate.getTime();
  };

  const { name, description, isRecursive, schedule } = scheduleData;
  return (
    <TicketSchedulerFormContainer className="grid">
      <div className="mt20 scheduler-name Header-Input">
        <TextField
          value={name}
          onChange={(val) => handleScheduleDataChange('name', val)}
          autoComplete="off"
          placeholder={getTranslatedText(
            intl,
            'admin.timeScheduler.form.placeholder.name'
          )}
          maxLength={TEXT_LENGTH.size_5}
          error={errors?.name}
        />
      </div>
      <div className="mt20 scheduler-description">
        <TextField
          value={description}
          onChange={(val) => handleScheduleDataChange('description', val)}
          autoComplete="off"
          multiline
          placeholder={getTranslatedText(
            intl,
            'admin.timeScheduler.form.placeholder.description'
          )}
          maxLength={1000}
        />
      </div>

      <div className="mt20 fx actr">
        <div className="mr-10">
          <RadioButton
            label={getTranslatedText(
              intl,
              'admin.timeScheduler.form.schedule.once.scheduleMessage'
            )}
            checked={!isRecursive}
            id="once"
            onChange={() => handleExecuteChange(false)}
            // disabled={!isEditAuthorised}
          />
        </div>
        {!isRecursive && (
          <>
            <DatePickerIconWrapper>
              <SVGIcon name="DatePicker" />
            </DatePickerIconWrapper>
            <DatePicker
              selected={dayjs(schedule?.data?.startDateAndTime).toDate()}
              filterTime={filterPassedTime}
              // filterDate={filterPassedDate}
              minDate={dayjs(new Date()).toDate()}
              onChange={handleScheduleChange}
              placeholderText="Choose date and time"
              dateFormat="yyyy-MM-dd, h:mm aa"
              required
              onKeyDown={(e) => e.preventDefault()}
              showTimeSelect
              timeIntervals={15}
              popperPlacement="right"
            />
          </>
        )}
      </div>
      <RecursiveContainer className="mt20 fx">
        <RadioButton
          label=""
          checked={isRecursive}
          id="recursive"
          onChange={() => handleExecuteChange(true)}
          // disabled={!isEditAuthorised}
        />
        <NewScheduleDuration
          filteredOptions={['MONTHLY', 'WEEKLY', 'HOURLY', 'DAILY']}
          updateParent={handleScheduleChange}
          duration={schedule}
          scheduleMessage={getTranslatedText(
            intl,
            'admin.timeScheduler.form.schedule.recursive.scheduleMessage'
          )}
          onScheduleMessageClick={() => handleExecuteChange(true)}
          // disableInterval={schedule?.frequency === 'MONTHLY'}
          disableInterval={!isRecursive}
          allowTime
          disablePastDateAndTime
          // showOccurance={!isRecursive}
          readOnly={!isRecursive}
          showInterval={isRecursive}
          hideStartEndDatetime={!isRecursive}
          // occurancei18nMap={{
          //   conjunctionText: 'schedule.info.message.once',
          //   placeholder: '',
          //   helpText: ''
          // }}
          errors={errors}
          // maxLimits={maxRepeatInterval}
        />
      </RecursiveContainer>
    </TicketSchedulerFormContainer>
  );
};

export default withErrorBoundary(injectIntl(TicketSchedulerForm));
